import * as React from 'react';
import * as randomColor from 'randomcolor';
import * as moment from 'moment';
import { Icon } from '../';
import BaseList from '../BaseList/BaseList';

class HolidayList extends BaseList {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.holidays.search,
      search: BaseList.search.holidays,
      path: 'settings/holidays',
      name: 'holidays',
    });
  }

  renderHead(item) {
    return <strong>{item.name}</strong>;
  }

  renderBody(item) {
    const start = moment(item.start).format('Do MMM YYYY');
    const end = moment(item.end).format('Do MMM YYYY');
    return (
      <span>
        <br />
        {start}
        {start !== end && <span>&nbsp;to {end}</span>}
      </span>
    );
  }

  renderLeft(holiday) {
    return (
      <span
        className="avatar image is-64x64"
        style={{
          backgroundColor: randomColor({
            seed: holiday.id * 2500,
            luminosity: 'light',
          }),
        }}
      >
        <Icon icon="calendar" size="large" />
      </span>
    );
  }
}

export default HolidayList;
